import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAlerts } from '../../../theme/hooks/useAlerts'
import { invalidateSubprocessenForEntityAfterTimeout } from '../../subprocessen/util/subproces-util'
import { uploadBijlagenForEntity } from '../services/uploadBijlagenForEntity'

import { queryKey as queryKeyAssignedBijlagen } from './useAssignedBijlagenForEntity'
import { queryKey as queryKeyBijlagen } from './useBijlagenForEntity'

export { useUploadBijlagenForEntity }

const useUploadBijlagenForEntity = () => {
  const queryClient = useQueryClient()
  const { successAlert } = useAlerts()

  return useMutation({
    mutationFn: uploadBijlagenForEntity,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [queryKeyBijlagen] })
      queryClient.invalidateQueries({ queryKey: [queryKeyAssignedBijlagen] })

      successAlert('Bijlage successvol aangepast')

      invalidateSubprocessenForEntityAfterTimeout(queryClient, variables.entity)
    },
  })
}
